import { gql } from '@parkchirp/api-client';

export const ACTIVATE_ALL_PARKERS = gql`
  mutation activateAllParkers(
    $facilityId: String
    $subscriptionId: String
    $createBackBillInvoices: Boolean
  ) {
    activateAllParkers(
      facilityId: $facilityId
      subscriptionId: $subscriptionId
      createBackBillInvoices: $createBackBillInvoices
    )
  }
`;

export const ACTIVATE_SELECTED_PARKERS = gql`
  mutation activateSelectedParkers(
    $parkerIds: [String!]!
    $createBackBillInvoices: Boolean
    $waitlist: Boolean
    $monthlyFeePrice: Int
    $parkerStartDate: String
  ) {
    activateSelectedParkers(
      parkerIds: $parkerIds
      createBackBillInvoices: $createBackBillInvoices
      waitlist: $waitlist
      monthlyFeePrice: $monthlyFeePrice
      parkerStartDate: $parkerStartDate
    ) {
      errors {
        subscriptionId
        failedParkers
        parkersAfterLastStartDate
        errorMessage
      }
    }
  }
`;

export const DELETE_PENDING_PARKERS_BY_SUBSCRIPTION = gql`
  mutation deletePendingParkersBySubscription(
    $parkerIds: [String]!
    $subscriptionId: String!
    $tenantSubscriptionId: String
    $waitlist: Boolean
  ) {
    deletePendingParkersBySubscription(
      parkerIds: $parkerIds
      subscriptionId: $subscriptionId
      tenantSubscriptionId: $tenantSubscriptionId
      waitlist: $waitlist
    ) {
      parkersWithErrors {
        parkerId
      }
    }
  }
`;

export const DELETE_PENDING_PARKERS_BY_SUBSCRIPTION_SQS = gql`
  mutation deletePendingParkersBySubscriptionSqs(
    $subscriptionId: String!
    $tenantSubscriptionId: String
  ) {
    deletePendingParkersBySubscriptionSqs(
      subscriptionId: $subscriptionId
      tenantSubscriptionId: $tenantSubscriptionId
    )
  }
`;
export const CHANGE_PENDING_PARKERS_START_DATE = gql`
  mutation changePendingParkersStartDateBySubscription(
    $parkerIds: [String]!
    $startDate: String!
    $subscriptionId: String!
    $tenantSubscriptionId: String
  ) {
    changePendingParkersStartDateBySubscription(
      parkerIds: $parkerIds
      startDate: $startDate
      subscriptionId: $subscriptionId
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      parkersWithErrors {
        parkerId
      }
    }
  }
`;

export const REMOVE_ACCESS_SYSTEM_META_FOR_SELECTED_PARKERS = gql`
  mutation removeAccessSystemMetaForSelectedParkers(
    $parkerIds: [String]!
    $subscriptionId: String!
  ) {
    removeAccessSystemMetaForSelectedParkers(
      parkerIds: $parkerIds
      subscriptionId: $subscriptionId
    )
  }
`;

export const REMOVE_ACCESS_SYSTEM_META_ON_SUBSCRIPTION_AND_PARKERS = gql`
  mutation removeAccessSystemMetaOnSubscriptionAndParkers(
    $subscriptionId: String!
  ) {
    removeAccessSystemMetaOnSubscriptionAndParkers(
      subscriptionId: $subscriptionId
    )
  }
`;

export const CREATE_PARKER_STATUS_HISTORY = gql`
  mutation createParkerStatusHistory(
      $parker_id: String!,
      $action: ParkerStatusHistoryActionEnum!,
      $start_date: String!,
      $end_date: String,
      $notes: String,
      $timezone: String,
      $tenantSubscriptionId: String,
      $skipProration: Boolean,
      $exceedingAmountDecision: ExceedingAmountDecisionEnum,
  ) {
      createParkerStatusHistory(
        parker_id: $parker_id,
        action: $action,
        start_date: $start_date,
        end_date: $end_date,
        notes: $notes,
        timezone: $timezone
        tenantSubscriptionId: $tenantSubscriptionId
        skipProration: $skipProration
        exceedingAmountDecision: $exceedingAmountDecision
      ) {
        id
      }
    }
`;

export const UPDATE_PARKER_STATUS_HISTORY = gql`
  mutation updateParkerStatusHistory(
      $id: String!,
      $parker_id: String!,
      $action: ParkerStatusHistoryActionEnum!,
      $start_date: String!,
      $end_date: String,
      $notes: String,
      $timezone: String,
      $tenantSubscriptionId: String,
      $skipProration: Boolean,
      $exceedingAmountDecision: ExceedingAmountDecisionEnum,
  ) {
      updateParkerStatusHistory(
         id: $id,
         parker_id: $parker_id,
         action: $action,
         start_date: $start_date,
         end_date: $end_date,
         notes: $notes,
         timezone: $timezone
         tenantSubscriptionId: $tenantSubscriptionId
         skipProration: $skipProration
         exceedingAmountDecision: $exceedingAmountDecision
      ) {
        id
      }
    }
`;

export const DELETE_PARKER_STATUS_HISTORY = gql`
  mutation deleteParkerStatusHistory(
      $id: String!,
      $tenantSubscriptionId: String,
      $parkerId: String!,
  ) {
      deleteParkerStatusHistory(
         id: $id,
         tenantSubscriptionId: $tenantSubscriptionId
         parkerId: $parkerId
      ) {
        delete_status
      }
    }
`;

export const ADMIN_TERMINATE_PARKER = gql`
  mutation adminTerminateParker(
    $parkerId: String!
    $terminationDate: String!
    $skipProration: Boolean!
    $exceedingAmountDecision: String
    $notes: String
  ) {
    adminTerminateParker(
      parkerId: $parkerId
      terminationDate: $terminationDate
      skipProration: $skipProration
      exceedingAmountDecision: $exceedingAmountDecision
      notes: $notes
    )
  }
`;

export const UPDATE_PARKER_ACCESS_SYSTEM_STATUS = gql`
  mutation updateParkerAccessSystemStatus(
      $parker_id: String!
      $access_system_status: ParkerAccessSystemStatusEnum!
      $tenantSubscriptionId: String
  ) {
      updateParkerAccessSystemStatus(
         parker_id: $parker_id
         access_system_status: $access_system_status
         tenantSubscriptionId: $tenantSubscriptionId
      ) {
        id
        rate_id
        suspension_status
        termination_status
      }
    }
`;

export const SET_PARKER_TO_NEUTRAL = gql`
  mutation setParkerToNeutral(
      $parkerId: String!,
      $tenantSubscriptionId: String
  ) {
      setParkerToNeutral(
        parkerId: $parkerId,
        tenantSubscriptionId: $tenantSubscriptionId
      )
    }
`;

export const PERFORM_BULK_PARKER_ACTION = gql`
  mutation performBulkParkerAction(
    $subscription_id: String!,
    $parker_ids: [String]!,
    $action: BulkParkerActionEnum!,
    $termination_date: String,
    $suspension_start_date: String,
    $suspension_end_date: String,
    $tenantSubscriptionId: String,
    $skipProration: Boolean,
    $exceedingAmountDecision: ExceedingAmountDecisionEnum,
  ) {
    performBulkParkerAction(
        subscription_id: $subscription_id,
        parker_ids: $parker_ids,
        action: $action,
        termination_date: $termination_date,
        suspension_start_date: $suspension_start_date,
        suspension_end_date: $suspension_end_date,
        tenantSubscriptionId: $tenantSubscriptionId,
        skipProration: $skipProration,
        exceedingAmountDecision: $exceedingAmountDecision
    )
  }
`;

export const CREATE_PARKER = gql`
  mutation createParker(
    $rateId: String!,
    $monthlyFeePrice: Int,
    $sublotId: Int!,
    $subscriptionId: String!,
    $parker: ParkerInputType!,
    $parkerVehicles: [VehicleInputType],
    $startDate: Date!,
    $tenantSubscriptionId: String
  ) {
      createParker(
        rateId: $rateId,
        monthlyFeePrice: $monthlyFeePrice,
        sublotId: $sublotId,
        subscriptionId: $subscriptionId,
        parker: $parker,
        parkerVehicles: $parkerVehicles,
        startDate: $startDate,
        tenantSubscriptionId: $tenantSubscriptionId
      ) {
        id
        parkerWarningMessage
      }
    }
`;

export const UPDATE_PARKER = gql`
  mutation updateParker(
    $id: String!,
    $rateId: String!,
    $sublotId: Int!,
    $subscriptionId: String!,
    $parker: ParkerInputType!,
    $parkerVehicles: [VehicleInputType],
    $startDate: Date!,
    $tenantSubscriptionId: String
  ) {
      updateParker(
        id: $id,
        rateId: $rateId,
        sublotId: $sublotId,
        subscriptionId: $subscriptionId,
        parker: $parker,
        parkerVehicles: $parkerVehicles,
        startDate: $startDate,
        tenantSubscriptionId: $tenantSubscriptionId
      ) {
        id
        parkerVehicles {
          id
          license
          make
          model
          state
          color
          decal
          startDate
          endDate
          year
          surchargeFeeNames
          vehicleHistory {
            id
            color
            licensePlate
            licenseState
            createdByUser {
                email
            }
            activeDate
            inactiveDate
            decal
          }
        }
        parkerWarningMessage
        surchargeWarning
      }
    }
`;

export const SEND_BARCODE_EMAIL = gql`
  mutation sendBarcodeEmail(
      $parkerId: String!
      $emailAddress: String!
      $tenantSubscriptionId: String
  ) {
      sendBarcodeEmail(
         parkerId: $parkerId
         emailAddress: $emailAddress
         tenantSubscriptionId: $tenantSubscriptionId
      )
    }
`;

export const SYNC_PARKER_IN_ACCESS_SYSTEM = gql`
  mutation syncParkerInAccessSystem(
    $parkerId: String!
  ) {
    syncParkerInAccessSystem(
      parkerId: $parkerId
    ) 
  }
`;

export const SYNC_PARKER_IN_CACHE = gql`
mutation syncParkerInCache(
  $parkerId: String!
) {
  syncParkerInCache(
    parkerId: $parkerId
  ) 
}
`;

export const ADD_BARCODES_TO_PARKERS_FOR_SUBSCRIPTION = gql`
mutation addBarcodesToParkersForSubscription(
  $subscriptionId: String!
) {
  addBarcodesToParkersForSubscription(
    subscriptionId: $subscriptionId
  ) 
}
`;

export const SYNC_ALL_PARKERS_IN_ACCESS_SYSTEM = gql`
  mutation syncAllParkersInAccessSystem($subscriptionId: String, $facilityId: String) {
      syncAllParkersInAccessSystem(subscriptionId: $subscriptionId, facilityId: $facilityId)
  }
`;
